import { RichTextContent } from 'ContentfulDefaults/types/_shared';
import { ContentfulBenefitsMedicalFSA } from 'ContentfulDefaults/types/benefitsMedicalFSA';

export const benefitsMedicalFSA: {
  benefits_section_medical_fsa: ContentfulBenefitsMedicalFSA;
} = {
  benefits_section_medical_fsa: {
    standalone_fsa_title: 'FSA de propósito limitado para cuidados médicos',
    lpfsa_title: 'FSA de propósito limitado para cuidados médicos',
    uses_federal_max_body:
      'Puede contribuir hasta el límite federal de {limit} por año a la FSA. Si está casado, su cónyuge puede contribuir por separado a una cuenta con su empleador, también hasta el límite federal.',
    not_federal_max_body:
      'Puede contribuir hasta el límite de {limit} por año a la FSA. Si está casado, su cónyuge puede contribuir por separado a una cuenta con su empleador, también hasta el límite federal de {fedLimit}. ',
    limited_purpose_uses_federal_max_body:
      'Puede contribuir hasta el límite federal de {limit} por año a la FSA de propósito limitado. Si está casado, su cónyuge puede contribuir por separado a una cuenta con su empleador, también hasta el límite federal. ',
    limited_purpose_not_federal_max_body:
      'Puede contribuir hasta el límite de {limit} por año a la FSA de propósito limitado. Si está casado, su cónyuge puede contribuir por separado a una cuenta con su empleador, también hasta el límite federal de {fedLimit}.',
    minimum_contribution_info: 'Esta cuenta también requiere una contribución mínima de {min} por año.',
    has_rollover_body:
      'Puede transferir hasta {amount} de los fondos sobrantes al plan del próximo año, pero perderá todo lo que supere ese monto. ',
    no_rollover_body:
      ' El dinero de esta cuenta es “úsalo o piérdelo,” lo que significa que debe gastar todo el dinero de la cuenta antes de la fecha límite o lo perderá.',
    federal_contribution_limit: 3200,
    contribution_limit_label: 'Límite de contribución:',
    eligible_expenses_title: 'Gastos elegibles',
    eligible_expenses_intro: 'Por lo general, puede usar una FSA para cuidados médicos en cosas como:',
    eligible_expenses_list: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'visitas al médico y recetas',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'vendas',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'medicamentos de venta libre',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'productos menstruales',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'solución para lentes de contacto, cirugía LASIK y anteojos recetados',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'pruebas de embarazo',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'visitas al quiropráctico y acupuntura',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'gastos dentales',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '\n',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
          ],
          nodeType: 'unordered-list',
        },
        {
          data: {},
          content: [{ data: {}, marks: [], value: '', nodeType: 'text' }],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    } as RichTextContent,
    eligible_expenses_irs_note: 'Para ver la lista completa, consulte {irsLink}.',
    lpfsa_eligible_expenses_intro:
      'Por lo general, puede usar una FSA de propósito limitado para cubrir el costo de cuidados dentales y de la vista, incluyendo cosas como:',
    lpfsa_eligible_expenses_list: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'anteojos recetados',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'cirugía ocular LASIK',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'solución para lentes de contacto',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'frenos dentales',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '\n',
                      nodeType: 'text',
                    },
                  ],
                  nodeType: 'paragraph',
                },
              ],
              nodeType: 'list-item',
            },
          ],
          nodeType: 'unordered-list',
        },
        {
          data: {},
          content: [{ data: {}, marks: [], value: '', nodeType: 'text' }],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    } as RichTextContent,
    important_deadlines_title: 'Fechas límite importantes',
    deadlines_with_rollover:
      'Debe gastar todos los fondos de la FSA excepto {rolloverAmt} antes del {incurDate}, o los perderá. Tiene hasta el {submitDate} para terminar de presentar cualquier reclamo.',
    deadlines_no_rollover:
      'Debe gastar todos los fondos de la FSA antes del {incurDate}, o los perderá. Tiene hasta el {submitDate} para terminar de presentar cualquier reclamo.',
    lpfsa_deadlines_with_rollover:
      'Debe gastar todos los fondos excepto {rolloverAmt} antes del {incurDate}, o los perderá. Tiene hasta el {submitDate} para terminar de presentar cualquier reclamo.',
    lpfsa_deadlines_no_rollover:
      'Debe gastar todos los fondos de la FSA de propósito limitado antes del {incurDate}, o los perderá. Tiene hasta el {submitDate} para terminar de presentar cualquier reclamo.',
  },
};

export default benefitsMedicalFSA;
